/// <amd-module name="Search/Shared/Components/SearchOverlay" />
export * from "./SearchOverlay/index";
